export function resolveTeacherHomeData({ classes, hasArchivedClasses }) {
    const isArchiveNotificationVisible = hasArchivedClasses && classes.length === 0;

    return { classes, isArchiveNotificationVisible };
}
